export default __webpack_public_path__ + "static/media/wellgo_reviewer5.fa3a9819.jpg";